'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _support = require('helpers/support');

var _Images = require('helpers/Images');

var _Images2 = _interopRequireDefault(_Images);

var _reactLazyload = require('react-lazyload');

var _reactLazyload2 = _interopRequireDefault(_reactLazyload);

var _defaultVoucherImage = require('assets/img/voucher/defaultVoucherImage.jpg');

var _defaultVoucherImage2 = _interopRequireDefault(_defaultVoucherImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RewardItemSmall = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(RewardItemSmall, _Component);

  function RewardItemSmall() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RewardItemSmall);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RewardItemSmall.__proto__ || (0, _getPrototypeOf2.default)(RewardItemSmall)).call.apply(_ref, [this].concat(args))), _this), _this.onErrorImage = function (event) {
      event.target.onerror = null;
      event.target.src = _defaultVoucherImage2.default;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RewardItemSmall, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          item = _props.item,
          style = _props.style,
          onPress = _props.onPress,
          onExchange = _props.onExchange,
          imgStyle = _props.imgStyle,
          isMyVoucher = _props.isMyVoucher;

      if (!item) return null;
      var countDown = item.countDown,
          title = item.title,
          name = item.name,
          image = item.image,
          shopName = item.shopName,
          address = item.address,
          newPrice = item.newPrice,
          oldPrice = item.oldPrice,
          exu = item.exu,
          star = item.star;

      var styles = require('./RewardItemSmall.scss');
      var buttonText = void 0;
      if (isMyVoucher) buttonText = 'Đặt lịch';else {
        if (exu && exu > 0) buttonText = '\u0110\u1ED5i ' + exu;else if (!exu) buttonText = 'Lấy voucher';
      }
      return _react2.default.createElement(
        'div',
        {
          className: styles.item + ' ' + style + ' ' + (active ? styles.active : ''),
          onClick: onPress
        },
        _react2.default.createElement(
          'div',
          { className: styles.body },
          _react2.default.createElement(
            'div',
            { style: { position: 'relative' } },
            _react2.default.createElement(
              _reactLazyload2.default,
              { height: 93 },
              _react2.default.createElement('img', {
                src: image,
                className: styles.rewardImage + ' ' + imgStyle,
                onError: this.onErrorImage
              })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.expireView },
              _react2.default.createElement(
                'div',
                { className: styles.expireText },
                'C\xF2n ',
                countDown,
                ' ng\xE0y'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.starView },
              _react2.default.createElement('img', {
                src: star === 5 ? _Images2.default.account.yellowStarIcon : _Images2.default.account.newStarIcon,
                className: styles.starIcon
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.contentView },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              name || title
            ),
            _react2.default.createElement(
              'div',
              { className: styles.addressView },
              _react2.default.createElement('img', {
                src: _Images2.default.account.address,
                className: styles.addressIcon
              }),
              _react2.default.createElement(
                'div',
                { className: styles.addressText },
                shopName
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.addressText },
              address
            ),
            _react2.default.createElement(
              'div',
              { className: styles.groupPrice },
              _react2.default.createElement(
                'div',
                {
                  className: styles.newPrice,
                  style: newPrice > 1000000 && oldPrice && oldPrice > 0 ? { fontSize: 12 } : null
                },
                _support.Helper.formatMoney(newPrice)
              ),
              !!(oldPrice && oldPrice !== 0) && _react2.default.createElement(
                'div',
                {
                  className: styles.oldPrice,
                  style: oldPrice && oldPrice > 10000000 ? { fontSize: 9 } : null
                },
                _support.Helper.formatMoney(oldPrice)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.middleView },
            _react2.default.createElement('div', { className: styles.dashLine })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.footer },
          _react2.default.createElement(
            'div',
            { className: styles.btn, onClick: onExchange },
            buttonText
          )
        )
      );
    }
  }]);
  return RewardItemSmall;
}(_react.Component), _class.propTypes = {
  item: _react.PropTypes.object,
  style: _react.PropTypes.string,
  imgStyle: _react.PropTypes.string,
  active: _react.PropTypes.bool,
  onPress: _react.PropTypes.func,
  onExchange: _react.PropTypes.func,
  isMyVoucher: _react.PropTypes.bool
}, _temp2);
exports.default = RewardItemSmall;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Reward/RewardItemSmall.js
// module id = 1631
// module chunks = 0